import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/engineering/services")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.services,
      moduleDescriptor: routeMessages.engineering,
      nav: {order: 5, visible: true},
    },
  },
});
